import { WorkspaceStore } from './types';

export const workspaceStoreSelectors = {
  getActiveWorkspaceId: (state: WorkspaceStore) => state.activeWorkspaceId,
};
